import type { ReactNode } from 'react';

export type StatTileIntent = 'neutral' | 'urgent' | 'warn' | 'success' | 'info';

export type StatTileProps = {
  label: string;
  value: ReactNode;
  secondary?: ReactNode;
  intent?: StatTileIntent;
};

const intentClasses: Record<StatTileIntent, string> = {
  neutral: 'bg-card border-border',
  urgent: 'bg-primary-soft border-primary-line',
  warn: 'bg-warn-bg border-warn-line',
  success: 'bg-success-bg border-success-line',
  info: 'bg-info-bg border-info-line',
};

const intentValueClasses: Record<StatTileIntent, string> = {
  neutral: 'text-foreground',
  urgent: 'text-primary',
  warn: 'text-warn',
  success: 'text-success',
  info: 'text-info',
};

export function StatTile({ label, value, secondary, intent = 'neutral' }: StatTileProps) {
  return (
    <div
      className={`rounded-card border p-4 shadow-card flex flex-col gap-1 ${intentClasses[intent]}`}
    >
      <span className="text-[11px] font-semibold uppercase tracking-wider text-foreground-mute">
        {label}
      </span>
      <span className={`text-2xl font-bold leading-tight ${intentValueClasses[intent]}`}>
        {value}
      </span>
      {secondary ? (
        <span className="text-xs text-foreground-mute">{secondary}</span>
      ) : null}
    </div>
  );
}
